import SiteHeader, { MAIN_CONTENT_ID } from '@components/shared/header/SiteHeader'
import BottomNav from '@components/shared/header/BottomNav'
import Footer from '@components/shared/Footer'
import ArticleSection from '@components/html/ArticleSection'
import AccountShell from '@components/account/shell/AccountShell'

import styles from 'styles/Main.module.css'

const MainLayout = ({ children, extraLinks, footerArticle,
    hideBottomNav, logoonly, navspace, nofooterdiv }) => {

    return (
        <>
            <SiteHeader logoOnly={logoonly} />
            <main className={styles.main} id={MAIN_CONTENT_ID}>
                { navspace && <NavSpace /> }
                <AccountShell>{ children }</AccountShell>
                { footerArticle &&
                    <ArticleSection article={footerArticle} id="artykul-stopka" /> }
                { extraLinks }
                <Footer nodiv={nofooterdiv} />
            </main>
            { !logoonly && !hideBottomNav && <BottomNav /> }
        </>
    )
}

export function NavSpace (props) {
    return <div className={styles['nav-space']} {...props} />
}

MainLayout.NavSpace = NavSpace

export default MainLayout